import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { UnpublishedChangesWarningModalDispatchParams, unpublishedChangesWarningModalSlice, UnpublishedChangesWarningModalState } from '@REDUCERS';

function createUnpublishedChangesWarningModalHook() {
    return function useUnpublishedChangesWarningModal(equalityFn?: EqualityFn<UnpublishedChangesWarningModalState>) {
        const state = useAppSelector((store) => store.unpublishedChangesWarningModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: UnpublishedChangesWarningModalDispatchParams) => dispatch(unpublishedChangesWarningModalSlice.actions.open(params)),
            close: () => dispatch(unpublishedChangesWarningModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createUnpublishedChangesWarningModalHook(); 